import { cn } from '@/libs/tw'

import { RoomOffer } from '../types'

type Props = {
	highlights: RoomOffer['highlights']
	showAll?: boolean
}
export const RoomFeatureTags = ({ highlights, showAll }: Props) => {
	return (
		<div className={cn('flex flex-wrap gap-12')}>
			{highlights.slice(0, showAll ? highlights.length : 3).map((hl) => (
				<div
					className={cn(
						'leading-16 flex min-h-32 w-fit items-center justify-center rounded-[20px] bg-roomSelection-tagBg px-12 text-roomSelection-tagText'
					)}
				>
					{hl}
				</div>
			))}
		</div>
	)
}
